import { Component, AfterViewInit, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { User } from '../../model/user';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'user-portal-select',
  templateUrl: './user-portal-select.component.html',
  styleUrls: ['./user-portal-select.component.scss'],
  standalone: false,
})
export class UserPortalSelectComponent implements OnInit, AfterViewInit {
  user?: User;

  userPortalsDropDownSettings = {
    enableCheckAll: false,
    enableFilterSelectAll: false,
    filterSelectAllText: '',
    filterUnSelectAllText: '',
    position: '',
    primaryKey: 'id',
    singleSelection: true,
    text: 'Select User Portal',
    selectAllText: '',
    unSelectAllText: '',
    enableSearchFilter: false,
    noDataLabel: 'User Not Registered on any Portals',
  };

  selectedItem = 0;
  userPortals: any = [];

  constructor(
    public dialogRef: MatDialogRef<UserPortalSelectComponent>,
    @Inject(MAT_DIALOG_DATA) public data: User
  ) {}

  ngOnInit() {
    console.log('ngOnInit');
    console.log(this.data);
    this.userPortals = [];
    this.userPortals = this.data.relMPortalAccess.map((portalAccess) => {
      return {
        id: portalAccess.portalRegisterId,
        itemName: portalAccess.portalName,
      };
    });
    console.log(JSON.stringify(this.userPortals));
    console.log(this.userPortals);
  }

  ngAfterViewInit(): void {
    // this.userPortals = this.data.relMPortalAccess.map(portalAccess => {
    //       return {id: portalAccess.portalRegisterId, itemName: portalAccess.portalName};
    //     }
    // );
  }

  selectPortal() {
    console.log('============================')
    console.log(this.selectedItem)
    console.log('============================')

    const portalArray = [];

    // for (let i = 0; i < this.selectedItem.length; i++) {
      const newItem = { id: this.selectedItem, itemName: 'test'};
      portalArray.push(newItem); // Add the new item to the array
    // }

    console.log('============================')
    console.log(portalArray)
    console.log('============================')

    this.dialogRef.close(this.selectedItem);
  }

  OnDeSelectAll() {
    this.selectedItem = 0;
  }
}
